import React from 'react';
import { Header } from './Header';
import { RankProgression } from './RankProgression';
import { KpiRow } from './KpiRow';
import { TeamGoalProgress } from './TeamGoalProgress';
import { MetricsGrid } from './MetricsGrid';
import { LoBreakdownTable } from './LoBreakdownTable';
import { BonusesDeductions } from './BonusesDeductions';
import { CompensationTiers } from './CompensationTiers';
import { FooterPillBar } from './FooterPillBar';
import { TrendingUp } from 'lucide-react';
export function Dashboard() {
  return <div className="min-h-screen bg-slate-50/50 font-sans text-slate-900" data-id="element-81">
      <Header data-id="element-82" />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-83">
        <div className="space-y-6" data-id="element-84">
          <RankProgression data-id="element-85" />

          <div className="pt-8 mt-8 border-t border-slate-200" data-id="element-86">
            <div className="flex items-center gap-3 mb-6" data-id="element-87">
              <div className="w-9 h-9 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shrink-0" data-id="element-88">
                <TrendingUp size={20} data-id="element-89" />
              </div>
              <h2 className="text-2xl font-black text-[#0a1e5e] uppercase tracking-tight" data-id="element-90">
                How You're Performing This Month
              </h2>
            </div>

            <div className="space-y-6" data-id="element-91">
              <KpiRow data-id="element-92" />
              <TeamGoalProgress data-id="element-93" />
              <MetricsGrid data-id="element-94" />
              <LoBreakdownTable data-id="element-95" />
              <BonusesDeductions data-id="element-96" />
            </div>
          </div>

          <div className="pt-8 mt-8 border-t border-slate-200" data-id="element-97">
            <CompensationTiers data-id="element-98" />
            <FooterPillBar data-id="element-99" />
          </div>
        </div>
      </main>
    </div>;
}